import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles, CircularProgress } from '@material-ui/core';

const styles = (theme) => ({
  wrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    padding: theme.spacing(2),
  },
  fullHeight: {
    height: `calc(100% - ${theme.spacing(4)}px)`,
  },
});

const CircularProgressWrap = ({ classes, fullHeight, ...otherProps }) => (
  <div className={classNames(classes.wrap, fullHeight && classes.fullHeight)}>
    <CircularProgress {...otherProps} />
  </div>
);

CircularProgressWrap.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  fullHeight: PropTypes.bool,
};

export default withStyles(styles)(CircularProgressWrap);
